<template>
    <div class="form-field" :class="{'error-input': errorItem}">
        <template v-if="field">
            <template v-if="field.permission ? $user.can(field.permission) : true">
                <label v-if="!isInlineInput(field)">{{field.label}}</label>
                <template v-if="field.options">
                    <select v-model="form[field.key]">
                        <option :value="undefined" selected disabled>Select {{field.label}}</option>
                        <option v-for="option in field.options" :key="option.value" :value="option.value">
                            {{option.name}}
                        </option>
                    </select>
                </template>
                <template v-else>
                    <input :type="field.type" :required="field.required" v-model="form[field.key]"
                    :min="field.min" 
                    :max="field.max"
                    :minlength="field.minlength" 
                    :maxlength="field.maxlength"
                    :true-value="1" 
                    :false-value="0"
                    :id="field.key">
                    <label :for="field.key" v-if="isInlineInput(field)">{{field.label}}</label>
                </template>
            </template>
        </template>
        <slot v-else></slot>
        <transition v-if="errorItem" name="slide" appear>
            <p class="field-error">{{errorItem.message}}</p>
        </transition>
    </div>

</template>

<script setup>
    import { computed } from 'vue';
    const props = defineProps({
        form: {
            type: Object
        },
        field: {
            type: Object
        },
        error: {
            type: Object
        }
    });

    let errorItem = computed(() => {
        return props?.error || null;
    });

    function isInlineInput(field) {
        return ['checkbox', 'radio'].includes(field.type);
    }
</script>